<template>
  <v-dialog v-model="show" width="500px">
    <v-card class="mt-2">
      <v-card-title>品種別上限本数追加</v-card-title>
      <v-card-actions>
        <v-btn @click="add">{{$t('app.buttons.add')}}</v-btn>
        <v-btn @click="back">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-form>
          <v-container fluid>
            <v-layout column>
              <v-flex>
                <remote-autocomplete
                  :label="$t('app.labels.productCode')"
                  url="products/kv"
                  v-model="productCode"
                />
              </v-flex>
              <v-flex>
                <v-text-field clearable label="受入上限本数" type="number" v-model="upperLimit"/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      productCode: null,
      upperLimit: null,
      resolve: null,
      reject: null
    }
  },
  methods: {
    popup() {
      this.show = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    add() {
      this.show = false
      this.resolve({
        productCode: this.productCode,
        upperLimit: this.upperLimit
      })
      this.productCode = null
      this.upperLimit = null
    },
    back() {
      this.show = false
    }
  }
}
</script>
